import { Subject } from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable()
export class ErrorStreamService {
  catchStream$ = new Subject();
}
